module.exports = require("!!vue-loader!../node_modules/v-markdown-loader/_cache/README-2.vue");


//////////////////
// WEBPACK FOOTER
// ./en/README.md
// module id = 112
// module chunks = 5